import { render, staticRenderFns } from "./Farm.vue?vue&type=template&id=4c928f2e&scoped=true&"
import script from "./Farm.vue?vue&type=script&lang=js&"
export * from "./Farm.vue?vue&type=script&lang=js&"
import style0 from "./Farm.vue?vue&type=style&index=0&id=4c928f2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c928f2e",
  null
  
)

export default component.exports